import { createContext } from 'react';

import { DirectorySchemaData } from 'api/types/data';
import {
  OrderEntity,
  OrderOperationType,
} from 'api/types/entity/account/order';

import {
  CurrenciesSchema,
  FinancialInstrumentsSchema,
  SenderOrRecipientDetailsSchema,
} from '../../types';

export interface OrderContextProps {
  schemas: DirectorySchemaData[] | undefined;
  isDisabledDirectoryFreeSolo?: boolean;
  orderType?: OrderOperationType;
  directories: {
    financialInstruments: FinancialInstrumentsSchema;
    currencies: CurrenciesSchema;
    senderOrRecipientDetails: SenderOrRecipientDetailsSchema;
  };
  brokerTimezoneOffset: number;
  order?: OrderEntity | null;
  disabledDates: Date[];
  minEndDate?: Date;
}

export const OrderContext = createContext<OrderContextProps | null>(null);
